import React, { useState, useEffect } from "react";

import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard, Mousewheel, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Include Swiper styles
import 'swiper/css/free-mode';
import { INLINES } from "@contentful/rich-text-types";

const ArchiveProject = ({ data }) => {

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };

    const formatDateDMYShort = (input) => {
        if (!input) return '';
        const d = new Date(input);
        if (isNaN(d)) return String(input);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yy = String(d.getFullYear()).slice(-2);
        return `${dd}.${mm}.${yy}`;
    };

    return (

        <>
            <section key={data.sys.id} className="section-archiveProject" >


                <div className='inner-container'>

                    <div className='date'><p>{formatDateDMYShort(data.fields.date)}</p></div>



                    <div className="phrase">
                        {documentToReactComponents(data.fields.titre, renderOptions)}

                    </div>

                    <div className="mySwiperContainer">

                        <Swiper
                            navigation={true}
                            modules={[Navigation, Keyboard, FreeMode]}
                            loop={true}
                            className="mySwiper"
                            keyboard={true}
                            mousewheel={true}

                            slidesPerView={'auto'}
                            freeMode={true}
                            spaceBetween={10}
                        >
                            {(data?.fields?.albumPhoto01 ?? [])
                                .filter(photo => photo?.fields?.file?.url)
                                .map((photo, photoIndex) => (
                                    <SwiperSlide key={photoIndex}>
                                        <img
                                            src={optimizeContentfulImage(photo.fields.file.url)}
                                            alt={`Slide ${photoIndex + 1}`}
                                            width={photo.fields.file.details?.image?.width}
                                            height={photo.fields.file.details?.image?.height}
                                        />
                                    </SwiperSlide>
                                ))}
                        </Swiper>

                    </div>

                    <div className="description">
                        {documentToReactComponents(data.fields.texte, renderOptions)}
                    </div>







                </div>
            </section>
        </>
    );
};

export default ArchiveProject;